module.exports = __webpack_public_path__ + "img/Skirt-Back-B10-Cb-back.cf9378a7.png";